// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__30gKn","search":"Settings_search__2NFMj","filter":"Settings_filter__EItR6"};